import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import {
  fetchHomepageIfNeeded,
  fetchRediscoverNetworkEntitiesIfNeeded,
  setRediscoverSelectedGenre,
  setRediscoverSelectedGenreNetwork,
  fetchRediscoverGenreDemoIfNeeded,
  fetchDiscoverGenreDemoSummaryIfNeeded,
  fetchRediscoverNetworkDetailsIfNeeded,
  setSelectedSidebarNav,
  logout
} from '../../actions'
import {
  makeRediscoverTopicIdSelector,
  makeRediscoverNetworkDetailsSelector,
  makeRediscoverThumbnailsSelector,
  makeRediscoverGenreDemoSelector,
  makeDiscoverDemoSummarySelector
} from '../../selectors'
import SidebarComponent from '../../components/sidebar/SidebarComponent'
import Profile from '../../classes/profile'
import RediscoverComponent from '../../components/rediscover/RediscoverComponent'
import { LS_HOMEPAGE_KEY } from '../../constants/local_storage'
import GoogleAnalytics from '../../classes/GoogleAnalytics'
import { DISCOVER_CONTENT_ANALYSIS } from '../../constants/commons'

class RediscoverContainer extends React.Component {
  static propTypes = {
    isAdmin: PropTypes.bool.isRequired,
    history: PropTypes.object,
    profile: Profile.PropTypes,
    homepage: PropTypes.object,
    shortcut: PropTypes.shape({
      id: PropTypes.string.isRequired,
      expires_at: PropTypes.string.isRequired,
      target: PropTypes.string.isRequired,
      target_id: PropTypes.string.isRequired
    }),
    logout: PropTypes.func.isRequired,
    location: PropTypes.object.isRequired,
    topicId: PropTypes.string,
    entities: PropTypes.object,
    genreDemo: PropTypes.object,
    demoSummary: PropTypes.object,
    rediscoverNetwork: PropTypes.object,
    selectedTopic: PropTypes.string,
    fetchHomepage: PropTypes.func.isRequired,
    fetchNetworkEntities: PropTypes.func.isRequired,
    setRediscoverSelectedGenre: PropTypes.func.isRequired,
    setRediscoverSelectedGenreNetwork: PropTypes.func.isRequired,
    fetchGenreDemo: PropTypes.func.isRequired,
    fetchGenreDemoSummary: PropTypes.func.isRequired,
    fetchNetworkDetails: PropTypes.func.isRequired,
    setShortcutPreference: PropTypes.func,
    shortcutPreference: PropTypes.string,
    selectedNav: PropTypes.string,
    isContentIntelligence: PropTypes.bool,
    isCatalogAnalysis: PropTypes.bool,
    isPerformanceAnalysis: PropTypes.bool,
    isAIInsights: PropTypes.bool,
    selectedSidebarNav: PropTypes.func
  }

  componentDidMount () {
    GoogleAnalytics.trackGA(DISCOVER_CONTENT_ANALYSIS, this.props.location, this.props.profile)
    const homepage = JSON.parse(localStorage.getItem(LS_HOMEPAGE_KEY))
    if (!homepage) {
      if (this.props.profile && this.props.profile.groups.length > 0) {
        const groups = this.props.profile.groups
        const groupName = groups.filter(group => group !== 'Admin')[0]
        this.props.fetchHomepage(groupName)
      }
    }
    if (this.props.topicId) {
      this.props.fetchNetworkDetails(this.props.topicId)
    }
  }

  componentDidUpdate (prevProps) {
    if (prevProps.shortcut !== this.props.shortcut && prevProps.topicId !== this.props.topicId && this.props.shortcut && this.props.topicId) {
      this.props.fetchNetworkDetails(this.props.topicId)
    }
  }

  render () {
    const { profile, location, entities, genreDemo, demoSummary, selectedNav, isContentIntelligence, isCatalogAnalysis, isPerformanceAnalysis, isAIInsights } = this.props
    const homepage = JSON.parse(localStorage.getItem(LS_HOMEPAGE_KEY))
    const myLogout = () => this.props.logout()
    return (
      <>
        <SidebarComponent
          isAdmin={this.props.isAdmin}
          profile={profile}
          logout={myLogout}
          location={location}
          homepage={homepage ? homepage : this.props.homepage}
          shortcut={this.props.shortcut}
          shortcutPreference={this.props.shortcutPreference}
          setShortcutPreference={this.props.setShortcutPreference}
          selectedSidebarNav={this.props.selectedSidebarNav}
          selectedNav={selectedNav}
          isContentIntelligence={isContentIntelligence}
          isCatalogAnalysis={isCatalogAnalysis}
          isPerformanceAnalysis={isPerformanceAnalysis}
          isAIInsights={isAIInsights}
        />
        <RediscoverComponent
          isAdmin={this.props.isAdmin}
          history={this.props.history}
          homepage={homepage ? homepage : this.props.homepage}
          topicId={this.props.topicId}
          shortcut={this.props.shortcut}
          entities={entities}
          genreDemo={genreDemo}
          demoSummary={demoSummary}
          rediscoverNetwork={this.props.rediscoverNetwork}
          fetchNetworkEntities={this.props.fetchNetworkEntities}
          fetchGenreDemo={this.props.fetchGenreDemo}
          fetchGenreDemoSummary={this.props.fetchGenreDemoSummary}
          setRediscoverSelectedGenre={this.props.setRediscoverSelectedGenre}
          setRediscoverSelectedGenreNetwork={this.props.setRediscoverSelectedGenreNetwork}
        />
      </>
    )
  }
}

function mapStateToProps () {
  const topicIdSelector = makeRediscoverTopicIdSelector()
  const rediscoverNetworkSelector = makeRediscoverNetworkDetailsSelector()
  const thumbnailSelector = makeRediscoverThumbnailsSelector()
  const genreDemoSelector = makeRediscoverGenreDemoSelector()
  const demoSummarySelector = makeDiscoverDemoSummarySelector()

  return (state, ownProps) => {
    const topicId = topicIdSelector(null, ownProps)
    const profile = state.user.profile && new Profile(state.user.profile)
    const isAdmin = state.user.isAdmin
    const shortcut = ownProps.shortcut
    const homepage = state.homepage.list
    const selectedNav = state.sidebar.selectedNav
    const isContentIntelligence = state.sidebar.isContentIntelligence
    const isCatalogAnalysis = state.sidebar.isCatalogAnalysis
    const isPerformanceAnalysis = state.sidebar.isPerformanceAnalysis
    const isAIInsights = state.sidebar.isAIInsights
    const selectedTopic = state.uMap.selectedTopic
    const entities = thumbnailSelector(state, ownProps)
    const genreDemo = genreDemoSelector(state, ownProps)
    const demoSummary = demoSummarySelector(state, ownProps)
    const rediscoverNetwork = rediscoverNetworkSelector(state, ownProps)

    return {
      isAdmin,
      profile,
      shortcut,
      homepage,
      topicId,
      selectedTopic,
      entities,
      genreDemo,
      demoSummary,
      rediscoverNetwork,
      selectedNav,
      isContentIntelligence,
      isCatalogAnalysis,
      isPerformanceAnalysis,
      isAIInsights
    }
  }
}

function mapDispatchToProps (dispatch) {
  return {
    fetchHomepage: (groupName) => dispatch(fetchHomepageIfNeeded(groupName)),
    fetchNetworkEntities: (network, genre, ids) => dispatch(fetchRediscoverNetworkEntitiesIfNeeded(network, genre, ids)),
    setRediscoverSelectedGenre: (genre) => dispatch(setRediscoverSelectedGenre(genre)),
    setRediscoverSelectedGenreNetwork: (network) => dispatch(setRediscoverSelectedGenreNetwork(network)),
    fetchGenreDemo: (genre, topicId, topicIds) => dispatch(fetchRediscoverGenreDemoIfNeeded(genre, topicId, topicIds)),
    fetchGenreDemoSummary: (genre, topicIds) => dispatch(fetchDiscoverGenreDemoSummaryIfNeeded(genre, topicIds)),
    fetchNetworkDetails: (topicId) => dispatch(fetchRediscoverNetworkDetailsIfNeeded(topicId)),
    selectedSidebarNav: (nav) => dispatch(setSelectedSidebarNav(nav)),
    logout: () => dispatch(logout())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(RediscoverContainer)
